import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind class merge helper.
 * `clsx` ile conditional class compose, `tailwind-merge` ile çakışan
 * utility'leri (`p-4` vs `p-6`) sonki kazanır şekilde resolve eder.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
